import { OctAutocomplete } from '@oceantech/oceantech-ui';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE, LEVEL } from 'src/app/modules/utils/Constant';
import { getDepartmentsByModule } from 'src/app/modules/utils/ServicesUtils';
import { DepartmentFilterProps } from './types';

const DepartmentFilter = ({
	value,
	onChange,
	moduleType,
	params,
	...props
}: DepartmentFilterProps) => {
	return (
		<OctAutocomplete
            options={[]}
			name="department"
			placeholder="Tất cả khoa phòng"
			menuPlacement="top"
			searchFunction={getDepartmentsByModule}
			searchObject={{
				moduleType,
				level: LEVEL.PHONG,
				pageIndex: DEFAULT_PAGE_INDEX,
				pageSize: DEFAULT_PAGE_SIZE,
				...params,
			}}
			isScroll
			urlData="data.content"
			value={value}
			onChange={onChange}
			{...props}
		/>
	);
};

export default DepartmentFilter;
